import * as React from 'react';
import type { SystemImage } from '@/types';

interface SystemImageProps {
  image: SystemImage;
}
export default function SystemImage(props: SystemImageProps): React.ReactElement | null {
  if(props.image) {
    const imageUrl = `/api/images/${props.image._id}`
    return (<img src={imageUrl} />)
  }
  return null;
}
